module.exports = __webpack_public_path__ + "img/burger-king.20e20a5c.png";